import React, { SVGProps } from 'react';

const SvgCustomNetherlands = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 512 512'
		xmlSpace='preserve'
		width='1em'
		height='1em'
		className='svg-icon'
		{...props}>
		<rect width='512' height='170.667' y='0' fill='#21468b' />
		<rect width='512' height='170.667' y='170.667' fill='#ffffff' />
		<rect width='512' height='170.667' y='341.333' fill='#ae1c28' />
	</svg>
);

export default SvgCustomNetherlands;
